import clsx from "clsx";

type SpaceProps = {
  className?: string;
};

export default function Space({ className }: SpaceProps) {
  return <div className={clsx("h-10", className)} />;
}
